import Nullstack from 'nullstack';
export default function IconScaleOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-scale-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M7 20h10"
  }), "   ", Nullstack.element("path", {
    d: "M9.452 5.425l2.548 -.425l6 1"
  }), "   ", Nullstack.element("path", {
    d: "M12 3v5m0 4v8"
  }), "   ", Nullstack.element("path", {
    d: "M9 12l-3 -6l-3 6a3 3 0 0 0 6 0"
  }), "   ", Nullstack.element("path", {
    d: "M18.873 14.871a3.001 3.001 0 0 0 2.127 -2.871l-3 -6l-2.677 5.355"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}